// extracted by mini-css-extract-plugin
export default {"container":"search-image_container__rmaHs","form":"search-image_form__t-bcg","submit-btn":"search-image_submit-btn__CkbxF","feedback":"search-image_feedback__FZwmi"};